/*
 *
 * VolumeDiscountPage actions
 *
 */

import {
  UPDATE_SELECTED_VARIANTS,
  UPDATE_VD_TOTAL_DISPLAY_OFFER_VALUES,
  UPDATE_VARIANT_SELECTOR_IN_VIEW,
  UPDATE_SELECTED_VD_OPTION_INDEX,
  UPDATE_SELECTED_VD_OPTION,
  UPDATE_VD_OFFER_THEME,
  UPDATE_VD_MR_OFFER_ID,
  UPDATE_VD_PRIMARY_PRODUCT,
} from './constants';

export function updateVDTotalDisplayOfferValue(datapack) {
  return {
    type: UPDATE_VD_TOTAL_DISPLAY_OFFER_VALUES,
    ...datapack,
  };
}

export function updateVDSelectedVariants(datapack) {
  return {
    type: UPDATE_SELECTED_VARIANTS,
    ...datapack,
  };
}

export function updateIsVDVariantSelectorInViewForAboveATC(datapack) {
  return {
    type: UPDATE_VARIANT_SELECTOR_IN_VIEW,
    ...datapack,
  };
}

export function updateSelectedVDOptionIndex(datapack) {
  return {
    type: UPDATE_SELECTED_VD_OPTION_INDEX,
    ...datapack,
  };
}

export function updateSelectedVDOption(datapack) {
  return {
    type: UPDATE_SELECTED_VD_OPTION,
    ...datapack,
  };
}

export function updateVDOfferTheme(datapack) {
  return {
    type: UPDATE_VD_OFFER_THEME,
    ...datapack,
  };
}

export function updateVDMrOfferID(datapack) {
  return {
    type: UPDATE_VD_MR_OFFER_ID,
    ...datapack,
  };
}

export function updateVDPrimaryProduct(datapack) {
  return {
    type: UPDATE_VD_PRIMARY_PRODUCT,
    ...datapack,
  };
}
